/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/views/LoadingSpinnerView.js"/>
/// <reference path="~/js/viz/profile/views/ProfileView.js"/>
/// <reference path="~/js/viz/profile/views/RawDataHrefView.js"/>
/// <reference path="~/js/viz/profile/views/PageTitleView.js"/>
/// <reference path="~/js/viz/profile/views/FacebookUrlView.js"/>
/// <reference path="~/js/viz/shared/routers/VizRouterBase.js"/>
/// <reference path="~/js/viz/profile/models/SelectorsModel.js"/>

(function(_) {
  var ns, sharedNs;

  ns = window.nspace("ccc.viz.profile");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.ProfileRouter = sharedNs.routers.VizRouterBase.extend({
    initialize: function(options) {
      var self;

      self = this;

      _.each(options, function(value, key) {
        self[key] = value;
      });

      _.bindAll(this);
    },

    routes: {
      "": "initializeViews",
      ":locationId": "initializeViews",
      ":locationId/:locationSlug": "initializeViews",
      ":locationId/:locationSlug/:locationTypeId": "initializeViews",
      ":locationId/:locationSlug/:locationTypeId/:indicatorIds":
        "initializeViews",
      ":locationId/:locationSlug/:locationTypeId/:indicatorIds/:dataTypeIds":
        "initializeViews",
      ":locationId/:locationSlug/:locationTypeId/:indicatorIds/:dataTypeIds/:otherFeatureIds":
        "initializeViews"
    },

    /**
     * This method will only ever be invoked a single time, so use it to initialize
     * the model/view classes and trigger the initial rendering
     */
    initializeViews: function(
      locationId,
      locationSlug,
      locationTypeId,
      indicatorIds,
      dataTypeIds,
      otherFeatureIds
    ) {
      var actualLocationId, actualLocationSlug, actualIndicatorIds;

      //// MODELS ////

      // Location and Indicator have defaults set on the server, so we can
      // fall back to these in case the route is null when we generate our
      // initial data requests.
      actualLocationId = this.availableLocations[locationId]
        ? locationId
        : this.defaultLocationId;
      actualLocationSlug =
        this.availableLocations[locationId] || this.defaultLocationSlug;
      actualIndicatorIds = indicatorIds || this.defaultIndicatorId;

      function getValue(raw) {
        if (raw === "a") {
          return null;
        }
        return raw;
      }

      // Create the selectors model, which represents anything that is selectable by the user and tracked in the URL
      this.selectorsModel = new ns.models.SelectorsModel({
        locationId: getValue(actualLocationId),
        locationSlug: getValue(actualLocationSlug),
        locationTypeId: getValue(this.locationTypeId),
        indicatorIds: this.getArrayFromModelProperty(actualIndicatorIds),
        dataTypeIds: this.getArrayFromModelProperty(dataTypeIds),
        otherFeatureIds: !otherFeatureIds
          ? ["a"]
          : this.getArrayFromModelProperty(otherFeatureIds)
      });

      // Create the data response model, the model that is responsible for querying the server-side for data,
      // storing the response, and triggering updates to other views after the response has been retrieved
      this.dataModel = new ns.models.DataResponseModel({
        selectorsModel: this.selectorsModel,
        dispatcher: this.dispatcher,
        dataUrl: "/api/ProfileData/GetProfileData"
      });

      //// VIEWS ////

      this.views = {
        // Loading spinner (no model required)
        loadingSpinner: new sharedNs.views.LoadingSpinnerView({
          dispatcher: this.dispatcher
        }),

        // Selectors. These must be instantiated late, since these views are used to bootstrap
        // the selectors model values, and certain other views need to hear when the selectors model changes.
        selectorsView: new ns.views.SelectorsView({
          model: this.selectorsModel,
          locationTypeId: this.locationTypeId,
          dispatcher: this.dispatcher,
          selectorUrl: "/api/selectors/GetSelectorInfoByIndicatorId",
          selectorData: {
            indicators: this.selectorsModel.get("indicatorIds").toString(),
            locationTypeId: this.selectorsModel.get("locationTypeId")
          }
        }),

        profileView: new ns.views.ProfileView({
          selectorsModel: this.selectorsModel,
          model: this.dataModel,
          el: "#data-table-container"
        }),

        rawDataHrefView: new ns.views.RawDataHrefView({
          model: this.dataModel
        }),

        pageTitleView: new ns.views.PageTitleView({
          model: this.selectorsModel
        }),

        noTableDataView: new ns.views.NoTableDataView({
          selectorsModel: this.selectorsModel,
          model: this.dataModel
        }),

        facebookUrlView: new ns.views.FacebookUrlView({
          model: this.selectorsModel
        })
      };

      this.completeRouterInitialization();
    },

    getValueOrDefault: function(val) {
      if (!val) {
        return "a";
      }
      return val;
    },

    routeUrlParts: function() {
      return [
        this.selectorsModel.get("locationId"),
        this.selectorsModel.get("locationSlug"),
        this.selectorsModel.get("locationTypeId"),
        this.getStringFromArrayProperty(
          this.selectorsModel.get("indicatorIds")
        ),
        this.getStringFromArrayProperty(this.selectorsModel.get("dataTypeIds")),
        this.getStringFromArrayProperty(
          this.selectorsModel.get("otherFeatureIds")
        )
      ];
    },

    initializeModelListeners: function() {
      // Listen for changes to the selectors model and update our URL
      this.selectorsModel.on("change", this.updateUrl);
    }
  });
})(_);
